import React from 'react'

export default function footer() {
    return (
        <div className="h-50  mx-auto box-border  justify-center bg-text-backgroundSecondary ">
          <h1 className="text-center text-white mt-7  opacity-75 "> @Tommy Huynh. All rights reserved </h1>   
        </div>
    )
}
